import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useNotificationsContext } from "./NotificationsProvider";

/**
 * /inbox is still a real URL — emails, push taps, the "no longer available"
 * page and older binaries all send people there — but the inbox itself is a
 * dialog. Arriving here opens it over the dashboard.
 */
const InboxRoute = () => {
  const { openInbox } = useNotificationsContext();

  useEffect(() => {
    openInbox();
  }, [openInbox]);

  return <Navigate to="/dashboard" replace />;
};

export default InboxRoute;
